import { lazy } from 'react';
import { Navigate } from 'react-router-dom';
import Loadable from 'components/Loadable';

// Páginas públicas
const LoginPage    = Loadable(lazy(() => import('pages/auth/Login')));
const RegisterPage = Loadable(lazy(() => import('pages/auth/Register')));

const LoginRoutes = {
  path: '/',
  // Si no usas un layout público, puedes omitir `element` aquí
  children: [
    // Ruta inicial -> Login
    { index: true, element: <LoginPage /> },

    // Rutas públicas explícitas
    { path: 'login', element: <LoginPage /> },
    { path: 'register', element: <RegisterPage /> },

    // Cualquier otra cosa en público redirige a /
    { path: '*', element: <Navigate to="/" replace /> }
  ]
};

export default LoginRoutes;
